import * as Icon from "react-feather";

function ReactFeather() {
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title">Feather icons</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                Icons
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Flag icons
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">React Feather icons</h4>
              <div className="icons-list row">
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Activity />
                  </i>
                  Activity
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Airplay />
                  </i>
                  Airplay
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.AlertCircle />
                  </i>
                  AlertCircle
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.AlertOctagon />
                  </i>
                  AlertOctagon
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.AlertTriangle />
                  </i>
                  AlertTriangle
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.AlignCenter />
                  </i>
                  AlignCenter
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.AlignJustify />
                  </i>
                  AlignJustify
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.AlignLeft />
                  </i>
                  AlignLeft
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.AlignRight />
                  </i>
                  AlignRight
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Anchor />
                  </i>
                  Anchor
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Aperture />
                  </i>
                  Aperture
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Archive />
                  </i>
                  Archive
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ArrowDown />
                  </i>
                  ArrowDown
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ArrowDownCircle />
                  </i>
                  ArrowDownCircle
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ArrowDownLeft />
                  </i>
                  ArrowDownLeft
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ArrowDownRight />
                  </i>
                  ArrowDownRight
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ArrowLeft />
                  </i>
                  ArrowLeft
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ArrowLeftCircle />
                  </i>
                  ArrowLeftCircle
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ArrowRight />
                  </i>
                  ArrowRight
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ArrowRightCircle />
                  </i>
                  ArrowRightCircle
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ArrowUp />
                  </i>
                  ArrowUp
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ArrowUpCircle />
                  </i>
                  ArrowUpCircle
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ArrowUpLeft />
                  </i>
                  ArrowUpLeft
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ArrowUpRight />
                  </i>
                  ArrowUpRight
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.AtSign />
                  </i>
                  AtSign
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Award />
                  </i>
                  Award
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.BarChart />
                  </i>
                  BarChart
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.BarChart2 />
                  </i>
                  BarChart2
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Battery />
                  </i>
                  Battery
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.BatteryCharging />
                  </i>
                  BatteryCharging
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Bell />
                  </i>
                  Bell
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.BellOff />
                  </i>
                  BellOff
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Bluetooth />
                  </i>
                  Bluetooth
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Bold />
                  </i>
                  Bold
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Book />
                  </i>
                  Book
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.BookOpen />
                  </i>
                  BookOpen
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Bookmark />
                  </i>
                  Bookmark
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Box />
                  </i>
                  Box
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Briefcase />
                  </i>
                  Briefcase
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Calendar />
                  </i>
                  Calendar
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Camera />
                  </i>
                  Camera
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.CameraOff />
                  </i>
                  CameraOff
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Cast />
                  </i>
                  Cast
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Check />
                  </i>
                  Check
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.CheckCircle />
                  </i>
                  CheckCircle
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.CheckSquare />
                  </i>
                  CheckSquare
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ChevronDown />
                  </i>
                  ChevronDown
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ChevronLeft />
                  </i>
                  ChevronLeft
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ChevronRight />
                  </i>
                  ChevronRight
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ChevronUp />
                  </i>
                  ChevronUp
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ChevronsDown />
                  </i>
                  ChevronsDown
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ChevronsLeft />
                  </i>
                  ChevronsLeft
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ChevronsRight />
                  </i>
                  ChevronsRight
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.ChevronsUp />
                  </i>
                  ChevronsUp
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Chrome />
                  </i>
                  Chrome
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Circle />
                  </i>
                  Circle
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Clipboard />
                  </i>
                  Clipboard
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Clock />
                  </i>
                  Clock
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.Cloud />
                  </i>
                  Cloud
                </div>
                <div className="col-6 col-md-3">
                  <i>
                    <Icon.CloudDrizzle />
                  </i>
                  CloudDrizzle
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReactFeather;
